module.exports = __webpack_public_path__ + "9779d9a1/img/link-icon.fa09ed66.svg";